// QR Kiosk v2 — dashboard tile board. Pass 1b 2026-07-24 (KV2_DESIGN_REVIEW_
// FEEDBACK.md §1b.8): EXACTLY four tiles in a fixed 2×2 order —
//   Open services (count) | Service archive
//   Tasks on this machine (count, self-hiding) | Machine manuals
// The "Detaily stroja" tile moved into the header card (now a spec-sheet button)
// and "Detaily spoločnosti" moved to Settings — both pages stay routed. DashTile
// atom + colored left accents + counts + 32px glyphs kept from Pass 1. Tokens only.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Machine } from "../../models/machinesModels";
import useTranslation from "../../../shared/hooks/useTranslation";
import { GD } from "../shared/glyphs";
import { getOpenReportsTone } from "./kioskLiveStatus";
import DashTile from "./DashTile";
import MyTasksRow from "../tasks/MyTasksRow";

export interface DashboardTileGridProps {
  machine: Machine;
  openCount: number;
}

export function DashboardTileGrid({ machine, openCount }: DashboardTileGridProps) {
  const navigate = useNavigate();
  const { translate } = useTranslation("public");
  const n = machine.internalNumber;

  // §3.5 nav guard — never emit /public-v2/machines/undefined/…
  const go = (path: string) => {
    if (machine?.internalNumber) navigate(path);
  };

  // v1 health thresholds preserved exactly (0 green · 1–2 amber · >2 red).
  const openTone = `var(${getOpenReportsTone(openCount)})`;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, margin: "10px 14px 0", flexShrink: 0 }}>
      {/* Row 1 — Open services | Service archive */}
      <DashTile
        glyph={GD.clip}
        label={translate("kioskOpenServices")}
        accent={openTone}
        count={openCount}
        onClick={() => go(`/public-v2/machines/${n}/service-reports/open`)}
      />
      <DashTile
        glyph={GD.hist}
        label={translate("kioskServiceArchive")}
        accent="var(--muted)"
        onClick={() => go(`/public-v2/machines/${n}/service-reports/archive`)}
      />
      {/* Row 2 — Tasks (KV2-7, self-hiding: Viewer / empty / failed → null) | Manuals */}
      <MyTasksRow machine={machine} />
      <DashTile
        glyph={GD.book}
        label={translate("kioskMachineManuals")}
        accent="var(--purple)"
        onClick={() => go(`/public-v2/documents/${n}`)}
      />
    </div>
  );
}

export default DashboardTileGrid;
